import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { Store } from '@ngrx/store';
import { combineLatest, first, map } from 'rxjs';
import { CheckDocumentsComponent } from '../../component/modals/check-documents/check-documents.component';
import { ApiState } from '../../model/api-state.model';
import { RemoteKind } from '../../model/remote-access.model';
import { FormsService } from '../../services/forms.service';
import { PersistStorageService } from '../../services/persist-storage.service';
import { ProcessService } from '../../services/process.service';
import { AppState } from '../../store';
import * as fromAttachments from '../../store/attachments/attachments.reducer';
import * as fromProcess from '../../store/process/process.reducer';
import * as fromRemote from '../../store/remote/remote.reducer';
import { ConfirmPayload } from '../../model/confirm.model';

@Component({
  selector: 'app-remote-id-consents',
  templateUrl: './remote-id-consents.component.html',
  styleUrls: ['./remote-id-consents.component.scss'],
})
export class RemoteIdConsentsComponent implements OnInit {
  id$ = this.activatedRoute.params.pipe(map(({ id }) => (id ? String(id) : null)));
  offerValue$ = this.store.select(fromRemote.selectOfferValue);
  remoteKind$ = this.store.select(fromRemote.selectRemoteKind);
  isAllDownloaded$ = this.store.select(fromAttachments.selectAttachmentsIsAllDownloaded);
  remoteHashCode$ = this.store.select(fromRemote.selectHashCode);

  formGroup = this.formsService.agreementsForm;
  apiStates = ApiState;
  modal: NxModalRef<CheckDocumentsComponent, any> | undefined;

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private formsService: FormsService,
    private processService: ProcessService,
    private dialogService: NxDialogService,
    private persistStorage: PersistStorageService,
  ) {}

  get remoteKindSuffix$() {
    return this.remoteKind$.pipe(map((remoteKind) => (remoteKind === RemoteKind.TravelAgency ? '-travelAgency' : '')));
  }

  ngOnInit(): void {
    this.store.dispatch(fromProcess.actions.setStep({ step: 10 }));

    this.processService.onPageInit();
  }

  showModal(): void {
    this.modal = this.dialogService.open(CheckDocumentsComponent, {
      panelClass: 'check-documents-modal',
      showCloseIcon: true,
      maxWidth: '1472px',
      width: '100%',
    });
  }

  goToPayments(): void {
    combineLatest([this.id$, this.isAllDownloaded$, this.remoteKind$, this.remoteHashCode$])
      .pipe(first())
      .subscribe(([id, isAllDownloaded, remoteKind, hashCode]) => {
        if (!isAllDownloaded) {
          this.store.dispatch(fromRemote.actions.pushNavigationError({ error: 'common.navigation-error.remote-consents' }));

          return;
        }

        if (remoteKind === RemoteKind.TravelAgency && hashCode) {
          const payload: ConfirmPayload = {
            hashCode,
            ...this.processService.apiPayload,
          };
          this.store.dispatch(fromProcess.actions.confirmStart({ payload }));
          this.store.dispatch(fromProcess.actions.setSuccess({ success: true }));
          void this.router.navigate(['page/success']);

          return;
        }

        this.store.dispatch(fromRemote.actions.setRemoteId({ remoteId: id }));
        void this.router.navigate(['remote', id, 'payment']);
      });
  }
}
